export default __webpack_public_path__ + "static/media/RETRACTABLE-PATIO-ENCLOSURE-NEW-DELHI.bdfcd310.jpg";